import { getDecodedAccess } from './auth';

export const AUTHORIZATION_VERSION = 1;

export function canUseRecommender(claims = getDecodedAccess()) {
  if (!claims || claims.authz_version !== AUTHORIZATION_VERSION) {
    return false;
  }
  return claims.can_use_recommender === true;
}
